import { NewsFeedItem } from './client';
import { NewsFeedItemServer } from './server';

export const normalizeNewsFeedItem = (
  item: NewsFeedItemServer
): NewsFeedItem => ({
  body: item.body,
  id: item.id,
  isTestActive: item.is_test_active,
  publishDate: item.publish_date,
  testSendSeq: item.test_send_seq,
  title: item.title
});

export const normalizeNewsFeedItems = (
  items: NewsFeedItemServer[]
): NewsFeedItem[] => items.map(normalizeNewsFeedItem);
